"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SystemStatus = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _globalTokens = require("../../../shared/global-tokens");
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var _Icon = require("../../media/icon/Icon");
var _jsxRuntime = require("react/jsx-runtime");
var SystemStatus = exports.SystemStatus = /*#__PURE__*/function (SystemStatus) {
  SystemStatus["RED"] = "red";
  SystemStatus["AMBER"] = "amber";
  SystemStatus["GREEN"] = "green";
  return SystemStatus;
}({}); // type SystemStatusType = typeof SystemStatus[keyof typeof SystemStatus];
var SystemStatusMessageWrapper = _styledComponents.default.div.withConfig({
  displayName: "SystemStatusMessage__SystemStatusMessageWrapper",
  componentId: "sc-1udodv5-0"
})(["min-width:320px;height:", ";border-style:solid;border-width:", ";border-color:", ";border-radius:", ";padding:", " ", ";"], _globalTokens.globalSizing['1100'], _globalTokens.globalBorder.width.thick, function (_ref) {
  var status = _ref.status;
  switch (status) {
    case SystemStatus.RED:
      return _globalTokens.globalColor.border.error;
    case SystemStatus.AMBER:
      return _globalTokens.globalColor.border.warning;
    case SystemStatus.GREEN:
    default:
      return _globalTokens.globalColor.border.success;
  }
}, _globalTokens.globalBorder.radius['2'], _globalTokens.globalSpacing['200'], _globalTokens.globalSpacing['400']);
var MessageRow = _styledComponents.default.div.withConfig({
  displayName: "SystemStatusMessage__MessageRow",
  componentId: "sc-1udodv5-1"
})(["display:flex;gap:", ";align-items:center;"], _globalTokens.globalSpacing['300']);
var LinkWrapper = _styledComponents.default.div.withConfig({
  displayName: "SystemStatusMessage__LinkWrapper",
  componentId: "sc-1udodv5-2"
})(["display:flex;align-items:center;height:100%;border-left:", " solid ", ";padding-left:", ";flex:0 0 auto;"], _globalTokens.globalBorder.width.thin, _globalTokens.globalColor.border.decorative, _globalTokens.globalSpacing['300']);
var LinkText = _styledComponents.default.div.withConfig({
  displayName: "SystemStatusMessage__LinkText",
  componentId: "sc-1udodv5-3"
})(["", ";color:", ";cursor:pointer;"], _tokens.default.sky.sys.font.link['1'], _globalTokens.globalColor.text.link.active);
var MessageWrapper = _styledComponents.default.div.withConfig({
  displayName: "SystemStatusMessage__MessageWrapper",
  componentId: "sc-1udodv5-4"
})(["", ";flex:1 0 auto;"], _tokens.default.sky.sys.font.body['1']);
var Link = function Link(_ref2) {
  var children = _ref2.children,
    onClick = _ref2.onClick;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(LinkWrapper, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(LinkText, {
      onClick: onClick,
      children: children
    })
  });
};
var Message = function Message(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(MessageWrapper, {
    children: children
  });
};
var getIcon = function getIcon(status) {
  switch (status) {
    case SystemStatus.RED:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        icon: "alert",
        color: "error"
      });
    case SystemStatus.AMBER:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        icon: "warning",
        color: "warning"
      });
    case SystemStatus.GREEN:
    default:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        icon: "checkCircle",
        color: "success"
      });
  }
};
var SystemStatusMessage = function SystemStatusMessage(_ref4) {
  var children = _ref4.children,
    status = _ref4.status;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(SystemStatusMessageWrapper, {
    status: status,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(MessageRow, {
      children: [getIcon(status), children]
    })
  });
};
SystemStatusMessage.STATUS = SystemStatus;
SystemStatusMessage.Link = Link;
SystemStatusMessage.Message = Message;
var _default = exports.default = SystemStatusMessage;